export class TicketLinkService {
    static $inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
    constructor(MessagingHubService, MESSAGINGHUBDOMAIN) {
        this.MessagingHubService = MessagingHubService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
    }
    async get(ticketId) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/ticket-link/${ticketId}`,
        });
    }
    async save(ticketId, linkedTicketId) {
        return await this.MessagingHubService.sendCommand({
            method: 'set',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/ticket-link/${ticketId}`,
            resource: {
                'linkedTicketId': linkedTicketId,
            },
            type: 'application/json',
        });
    }
    async delete(ticketId) {
        return await this.MessagingHubService.sendCommand({
            method: 'delete',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/ticket-link/${ticketId}`,
        });
    }
}
TicketLinkService.$inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
